import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

import FormLoansModal from './FormLoansModal';
import { LEAD_DETAILS_OVERLAYS } from '~/features/leadDetails/constants/overlays';
import { useLeadDetailsModalNavigation } from '~/features/leadDetails/hooks/useLeadDetailsModalNavigation';

type Props = {
    lead: SchemaLoanRequestResolver_Get;
};

export const RouteFormLoansModal: React.FC<Props> = ({ lead }) => {
    const { closeModal, isModalOpen } = useLeadDetailsModalNavigation();

    if (!isModalOpen(LEAD_DETAILS_OVERLAYS.FORM_LOANS)) return null;

    return <FormLoansModal lead={lead} onClose={() => closeModal(LEAD_DETAILS_OVERLAYS.FORM_LOANS)} />;
};
